<template>
  <div class="myCertification">
    <van-nav-bar title="认证信息" fixed @click-left="$router.back()" />
    <div class="head"><img src="@/assets/image/my/组 634@2x.png" /></div>

    <div class="myCertification-form">
      <van-form @submit="onSubmit">
        <van-field v-model="form.real_name" name="医生姓名" label="医生姓名" placeholder="请输入医生姓名"
          :rules="[{ required: true, message: '请输入医生姓名' }]" required />

        <van-field name="性别" label="性别" :rules="[{ required: true, message: '请选择性别' }]" required>
          <template #input>
            <van-radio-group v-model="form.sex" direction="horizontal">
              <van-radio :name="1">男</van-radio>
              <van-radio :name="2">女</van-radio>
            </van-radio-group>
          </template>
        </van-field>

        <van-field v-model="form.unit" name="医院" label="医院" placeholder="输入所在单位"
          :rules="[{ required: true, message: '请输入单位地址' }]" required />
        <van-field v-model="form.department" name="科室" label="科室" placeholder="请输入科室"
          :rules="[{ required: true, message: '请输入科室' }]" required />
        <van-popup v-model="showPicker" position="bottom">
          <van-picker show-toolbar :columns="columns" @confirm="onConfirm" @cancel="showPicker = false" />
        </van-popup>

        <van-field readonly clickable name="职称" :value="value" label="职称" placeholder="请选择职称" @click="showPicker = true"
          :rules="[{ required: true, message: '请选择职称' }]" required />

        <van-field v-model="form.id_card_number" name="身份证号" label="身份证号" placeholder="请输入身份证号" :rules="[
          { required: true, message: '请输入身份证号' },
          { validator: peopleID, message: '身份证号格式不正确' },
        ]" required />

        <van-field name="certificate" label="资质图片">
          <!-- :rules="[{ required: true, message: '请上传资质图片' }]" required  -->
          <template #input>
            <van-uploader v-model="fileList3" :max-count="1" :after-read="afterRead3" :before-delete="deluploder" />
          </template>
        </van-field>

        <van-cell @click="showPopup = true">查看示例</van-cell>
        <van-popup v-model="showPopup">
          <div style="padding: 15px 13px;">
            <div style="color: #393939;font-size: 16px;margin-bottom: 14px;text-align: center;">示例图</div>
            <div style="width: 260px;height: 121px;"><img src="@/assets/image/my/shili.png"></div>
          </div>
        </van-popup>

        <div class="mvoe-checked">
          <van-checkbox v-model="checked" shape="square">我已阅读同意</van-checkbox>
          <div style="display: flex;align-items: center;justify-content: space-between;margin-left: -6px;">
            <div class="mvoe-checked-name" @click="show = true">
              《病例集用户协议》
            </div>
            <div class="mvoe-checked-name" @click="show2 = true">
              《知情同意书》
            </div>
            <div class="mvoe-checked-name" @click="show3 = true">
              《免责声明》
            </div>
          </div>
        </div>
        <van-popup v-model="show" style="width: 80%; max-height: 80%">
          <div class="popup-text">
            <h3 style="margin-bottom: 10px">用户注册隐私协议</h3>
            <h4>一、前言</h4>
            我们非常重视用户的隐私和个人信息的保护。因此，我们制定了本隐私协议，以明确我们在用户注册、使用我们的服务过程中，如何收集、使用、存储、共享和保护您的个人信息。请您在注册前，仔细阅读本隐私协议。
            <br />
            <h4>二、信息的收集和使用</h4>
            1.
            当您注册我们的服务时，我们可能会要求您提供一些必要的个人信息，例如：姓名、电子邮件地址、手机号码、密码等。这些信息将用于创建您的账户、提供服务和改进我们的产品。<br />
            2. 我们可能会使用您的个人信息进行以下活动：<br />
            - 验证您的身份；<br />
            - 提供和改进我们的服务； <br />
            - 发送与您相关的通知和更新； <br />
            - 进行市场分析和研究，以优化我们的产品和服务。
            <br />
            3. 我们将仅在您同意或法律法规允许的情况下，使用您的个人信息。
            <h4>三、信息的存储和保护</h4>
            1.
            我们将采取合理的技术和管理措施，保护您的个人信息不被未经授权的访问、使用、泄露、损坏或丢失。<br />
            2.
            您的个人信息将存储在我们的服务器上，我们可能将服务器设在国内或国外。我们承诺，无论存储在哪里，我们都会遵守中国的法律法规，并采取必要的安全措施。
            <h4>四、信息的共享</h4>
            1. 我们不会将您的个人信息共享给任何第三方，除非： <br />
            - 您明确同意； <br />
            - 我们需要遵守法律法规或法院命令； <br />
            -
            为了向您提供服务，我们需要与第三方合作伙伴共享您的信息，但我们会与这些合作伙伴签订严格的保密协议。
            <br />
            2.
            在某些情况下，我们可能会将您的个人信息进行匿名化或汇总，然后用于研究和开发等目的。此时，您的个人信息将无法被识别。
            <br />
            <h4>五、您的权利</h4>
            1. 您有权要求我们提供您的个人信息副本。<br />
            2. 您有权要求我们更正或删除您的个人信息。<br />
            3.
            您有权拒绝我们收集或使用您的个人信息，但这可能会影响到您使用我们的服务。<br />
            4. 如果您对我们的隐私政策有任何疑问或投诉，您可以随时联系我们。<br />
            <h4>六、隐私政策的变更</h4>
            我们可能会不时地更新本隐私政策，以适应我们的服务变更或法律法规的要求。我们会通过公告、电子邮件或其他方式通知您任何变更。请定期查看本隐私政策，以确保您了解最新的隐私保护措施。
            <h4>七、其他</h4>
            本隐私政策适用于我们所有的服务，但某些特定的服务可能有额外的隐私条款。如果有任何冲突，以特定服务的隐私条款为准。
            <h4>八、联系方式</h4>
            如果您对我们的隐私政策有任何疑问或投诉，请通过以下方式与我们联系：[xuzp@high-med.com]
            或 [18033805790]。我们将尽快回复您的请求。<br />
            感谢您花时间阅读我们的隐私政策。我们承诺将尽最大的努力保护您的隐私和个人信息
          </div>
        </van-popup>

        <van-popup v-model="show2" style="width: 80%; max-height: 80%">
          <div class="popup-text">
            <h3 style="margin-bottom: 10px">淋巴瘤CAR-T治疗全程管理项目用户知情同意</h3>
            <h4>一、项目背景</h4>
            我国最常见的淋巴瘤类型是弥漫大B细胞淋巴瘤（DLBCL），占所有淋巴瘤患者的33.27％。《CSCO淋巴瘤诊疗指南》指出，对于复发/难治性DLBCL患者，可选择其他与CHOP无交叉耐药的药物个体化方案。LBCL一线治疗近40%会出现复发，现行HDT-ASCT治愈率仅10%，LBCL二线治疗存在大量未满足需求。CAR-T细胞治疗作为新兴的治愈性方案实现较传统标准治疗心得突破。CAR-T细胞治疗已获得CSCO、NCCN指南推荐I类推荐。
            <br />
            CAR-T细胞与传统治疗模式有较大差异，治疗涉及多个关键流程节点，规范化应用至关重要。中国已迎来商业化CAR-T二线适应症，以CAR-T为基础的多种药物合理桥接，联合等治疗策略逐渐被临床所接受。CAR-T治疗从单采、转运、桥接、回输、维持治疗随访等各节点都需要建立规范化标准和个体化规范建议，需要临床医护，企业及社会共同促进其规划化诊疗从治疗中最大化获益。
            <br />
            为了推动CAR-T治疗的规范化诊治，调研血液领域大B淋巴瘤诊疗观念、最新治疗进展如CAR-T治疗的临床应用，中国医药教育协会计划发起“淋巴瘤CAR-T治疗全程管理项目”，项目将邀请权威专家参与，完成DLBCL观念问卷，提供DLBCL临床诊治病例；通过科室讨论确认患者治疗方案；并将治疗理念和方法通过视频和图文的形式在医学媒体平台上发布，扩大影响、形成诊疗规范。
            <br />
            <h4>二、项目总体流程</h4>
            项目计划在2024年10月-2025年5月开展，通过面向全国各医疗机构的卫生专业人士，按照研究方案，收集、整理、分析、汇总与统计关于大B细胞淋巴瘤临床诊疗相关的医学临床诊疗信息，并进一步对临床诊疗信息进行医学诊疗分析和医学研究，最终形成有价值的研究成果，供医疗卫生领域的专家学者参考，以期更好的应用于诊疗实践，创造学术或临床价值。
            <br />
            （一）医生注册
            <br />
            医生在线进行用户信息注册。
            <br />
            （二）医生信息完善
            <br />
            医生注册用户成功后，需要在线完善本人基本信息，包括姓名、医院、科室、职称、身份证号码，以便核实医生的身份。
            <br />
            （三）诊疗观念调研、案例征集及相关医学材料建立
            <br />
            在线注册本项目成功并将基本信息完善后的医生进入项目平台活动专区，医生可以选择点击观念调研阶段，参与临床诊疗调研及案例征集项目。医生可以选择点击填写问卷，回答调研问卷，或者医生可以选择按照案例模板点击上传整理的案例信息并进行提交，由平台进行审核项目办进行复核。
            （四）医生劳务费
            <br />
            支持医生用于本项目健康医学的费用，根据医生在本项目工作实际开展情况结算费用。
            <h4>三、参与要求</h4>
            本项目参与对象:
            <br />
            参与本项目且符合支付条件的全国各医疗机构的卫生专业人士。
            <br />
            <h4>四、项目办公室特别声明</h4>
            （一）医生应确保患者本人应知情并自愿参与本项目，患者是否符合参与要求及医学标准，最终由医生决定。
            <br />
            （二）对于案例信息及医学资料（“案例信息和资料”），我们将严格保密，不会用于任何商业用途。案例信息和资料将由主办方和项目委托执行机构保留，除卫生监管部门审查监督外，不会披露给其他第三方。
            <br />
            （三）医生提交的案例信息应保证其真实性，不得拼凑和杜撰。医生提交案例时，案例内容需经过患者本人同意，并将案例内容中的信息进行脱敏处理。医生在收集患者资料前，对于可能存在的超适应症用药情况，应进行充分的临床获益及风险评估，并且应当保证患者知情，且明确告知患者收集其信息的目的、范围与方式，不得误导、欺诈或者隐藏等其他方式收集信息，还应遵循合理、必要、正当、权益损害最小原则。
            <br />
            （四）医生应严格按照医学研究的相关法律规范开展项目，不得利用本项目之便进行违法行为，否则将自行并承担因违反相关政策和法规相应的责任。
            <br />
            （五）医生同意项目办通过获取的银行支付信息支付符合要求的服务相关费用。
            <br />
            （六）中国医药教育协会为项目主办方，拥有项目成果的归属权；本项目知识产权归属主办方和研究者共同享有，研究成果应用于健康公益事业，不能用于商业用途。
            <br />
            （七）本平台对医生提供的案例信息不承担任何法律责任，当发生版权纠纷或其他侵害第三方合法权益纠纷时，医生须负责提供相应证据说明资料并解决由此产生的纠纷。
            <br />
            （八）如果您作为平台用户访问并使用了本平台，将被视作您已阅读、理解并同意本内容。如您不同意本内容或不同意参与本项目，请勿使用本平台或提交案例信息/完成调研问卷，请直接关闭退出。
            <br />
            （九）本项目保留随时修改本内容的权利，如果本内容修改，本平台会及时通知您，并再次征求您是否同意。
            <br />
            （十）“淋巴瘤CAR-T治疗全程管理项目”的一切解释权归中国医药教育协会所有。
            <br /><br />
            <div style="text-align: right;">
              中国医药教育协会项目办
              <br />
              2024年10月
            </div>
          </div>
        </van-popup>

        <van-popup v-model="show3" style="width: 80%; max-height: 80%">
          <div class="popup-text">
            <h3 style="margin-bottom: 10px">免责声明</h3>
            欢迎访问本网站。本网站所载信息只为在中华人民共和国正式取得执业资格的医疗卫生专业人员所提供。在访问和使用本网站之前，请认真阅读下列使用条款。如果您访问或使用了本网站，即说明您已经阅读、理解并同意遵守本使用条款。如果您不同意本使用条款，您将不能访问或使用本网站。
            <br /><br />
            本平台所有者将尽其合理努力于本平台提供更新和准确的信息，但对所提供信息的准确性、及时性或完整性不作任何陈述、担保或保证。本平台所有者对您由于访问或不能访问本平台或者因依赖本平台所提供信息而产生的任何损失或损害不承担任何责任。
            <br /><br />
            本平台可能含有对其他平台的链接或引用，但本平台所有者对该等其他平台的内容不承担任何责任，而且对该等内容所导致的损失或损害不承担任何责任。所有对其他平台的链接仅为方便本平台用户而提供。
            <br /><br />
            如果您是医疗卫生专业人士，那么您进一步理解并同意，您是作为医学领域独立的专业人士接受我们提供的所有信息，并将对该等信息做出独立的医学判断；您的处方、推荐、采购和/或其他专业行为和/或决定将不会因我们向您提供上述信息而受到任何不正当的影响。为向您提供更好的用户服务，包括为您提供定制化内容，我们可能将收集并保存您的部分个人信息，包括姓名、联系方式、医院、科室、职称等。我们将仅为前述目的而收集和使用您的个人信息。我们可能将在您登记浏览本平台内容时，或在您自愿提供信息的其他情况下收集您的上述个人信息。我们可能将从您这里收集的个人信息与从其他服务或从第三方获得的信息进行整合。
            <br /><br />
            接受本协议将视为同意接受本平台所有者发送的内容，包括但不仅限于电话/短信/邮件/APP等渠道。
          </div>
        </van-popup>
        <div class="myCertification-btn">
          <van-button round block type="info" native-type="submit">提交</van-button>
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
import getBankcardinfo from "bankcardinfo";
import { areaList } from "@vant/area-data";
export default {
  name: "certification",
  data() {
    return {
      showPopup: false,
      show: false,
      show2: false,
      show3: false,
      checked: false,
      areaList,
      showArea: false,
      value: "",
      columns: ["住院医师", "主治医师", "副主任医师", "主任医师"],
      showPicker: false,
      // action: `http://api.henlius.netloop.cn/api/system/upload`,
      action: `https://up-z0.qiniup.com`,
      fileList1: [],
      fileList2: [],
      fileList3: [],
      fileList4: [],
      fileList5: [],
      form: {
        real_name: "", //医生姓名 
        sex: '',//性别 
        unit: "", //医院
        department: "", //科室
        title: "", //职称   
        id_card_number: "", //身份证号 
        certificate: "", //医师证 
      },
    };
  },
  methods: {
    //手机号验证
    isMobileNumber(val) {
      return /^1[3456789]\d{9}$/.test(val);
    },
    //身份证号验证
    peopleID(val) {
      return /(^\d{9}$)|(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(val);
    },
    bankNumberchange(num) {
      getBankcardinfo.getBankBin(num.target._value, (err, data) => {
        console.log("提示" + err);
        if (!err) {
          this.form.bank = data.bankName;
        } else {
          this.form.bank = "";
          this.$toast("银行卡号不正确");
        }
      });
    },
    //银行卡正
    async bankZ(file) {
      // 此时可以自行将文件上传至服务器
      let formData = new FormData();
      formData.append("file", file.file);
      const { data: data } = await this.$http.post("/system/upload", formData);
      this.form.bank_1 = data.data.url;
    },
    //银行卡反
    async bankF(file) {
      // 此时可以自行将文件上传至服务器
      let formData = new FormData();
      formData.append("file", file.file);
      const { data: data } = await this.$http.post("/system/upload", formData);
      this.form.bank_2 = data.data.url;
    },
    //身份证正
    async afterRead1(file) {
      let time = Math.round(Math.random() * 80 + 20);
      let imgName = file.file.name.slice(file.file.name.lastIndexOf(".") + 1);

      file.status = "uploading";
      file.message = "上传中...";
      const { data: data } = await this.$http.get("system/qiniuToken");
      let formData = new FormData();
      formData.append("token", data.data.token);
      formData.append("file", file.file);
      formData.append("key", new Date().getTime() + time + "." + imgName); //file.file.name   Math.round(Math.random() * 80 + 20)) +
      this.$http.post("https://up-z0.qiniup.com/", formData).catch((err) => {
        console.log(err);
        this.$toast("上传成功");
        this.form.id_card1 = `https://resources.car-t.medcase.com.cn/${err.key}`;
        file.status = "done";
      });
    },
    //身份证反
    async afterRead2(file) {
      let time = Math.round(Math.random() * 80 + 20);
      let imgName = file.file.name.slice(file.file.name.lastIndexOf(".") + 1);
      //1111111111111111111111111111111111111111111
      file.status = "uploading";
      file.message = "上传中...";
      const { data: data } = await this.$http.get("system/qiniuToken");
      let formData = new FormData();
      formData.append("token", data.data.token);
      formData.append("file", file.file);
      formData.append("key", new Date().getTime() + time + "." + imgName);
      this.$http.post("https://up-z0.qiniup.com/", formData).catch((err) => {
        console.log(err);
        this.form.id_card2 = `https://resources.car-t.medcase.com.cn/${err.key}`;
        this.$toast("上传成功");
        file.status = "done";
      });
    },
    //医师资格证
    async afterRead3(file) {
      let time = Math.round(Math.random() * 80 + 20);
      let imgName = file.file.name.slice(file.file.name.lastIndexOf(".") + 1);

      file.status = "uploading";
      file.message = "上传中...";
      const { data: data } = await this.$http.get("system/qiniuToken");
      let formData = new FormData();
      formData.append("token", data.data.token);
      formData.append("file", file.file);
      formData.append("key", new Date().getTime() + time + "." + imgName);
      this.$http.post("https://up-z0.qiniup.com/", formData).catch((err) => {
        console.log(err);
        this.form.certificate = `https://resources.car-t.medcase.com.cn/${err.key}`;
        this.$toast("上传成功");
        file.status = "done";
      });
    },
    //职称选择
    onConfirm(value) {
      this.value = value;
      this.form.title = value;
      this.showPicker = false;
    },
    //提交
    async onSubmit(values) {
      if (!this.checked) {
        this.$toast("请勾选同意协议并阅读");
        return;
      }
      const { data: data } = await this.$http.post(
        "auth/cert",
        this.form
      );
      this.$dialog
        .alert({
          title: "温馨提示",
          message: "完善个人信息成功",
        })
        .then(() => {
          this.$router.push("homeTopic");
        });
    },
    //删除文件
    deluploder(file, detail) {
      return new Promise((resolve, reject) => {
        this.$dialog.confirm({
          message: '确定删除图片？'
        }).then(() => {
          this.fileList3.splice(detail.index, 1)
          this.form.certificate = ''
          this.$toast.success('删除成功')
          resolve()
        }).catch((error) => {
          this.$toast.success('已取消')
          reject(error)
        })
      })
    },
  },
};
</script>
<style lang="less" scoped>
.myCertification {
  padding: 46px 15px 50px; //顶部导航46px 底部导航50px 左右15
  position: relative;
  overflow: hidden;

  .head {
    width: 108%;
    position: absolute;
    top: -20px;
    left: -4%;
  }

  .myCertification-form {
    margin-top: 20px;
  }

  /deep/.van-cell {
    padding-top: 15px;
    padding-bottom: 15px;
  }

  .myCertification-btn {
    margin-top: 30px;

    /deep/.van-button {
      height: 36px;
    }

    /deep/ .van-button--info {
      color: #fff;
      background: linear-gradient(105deg, #A04BA5 0%, #A04BA5 100%);
      border: 1px solid #A04BA5;
    }
  }
}

.mvoe-checked {
  // display: flex;
  // align-items: center;
  margin-left: 20px;
  margin-top: 10px;

  /deep/.van-checkbox__label {
    font-size: 14px !important;
    margin-top: 3px;
    color: #ccc !important;
  }

  /deep/.van-checkbox__icon .van-icon {
    width: 15px !important;
    height: 15px !important;
    margin-top: 3px;
    font-size: 12px;
  }

  .mvoe-checked-name {
    font-size: 14px;
    margin-top: 5px;
    // margin-left: 10px; 
    color: rgb(4, 188, 196);
  }
}

.popup-text {
  padding: 15px;
}
</style>
